<ng-container *ngIf="stream$ | async as stream">
  <ng-container *ngIf="isStreamShouldBeCanvased$ | async; else plainVideo">
    <app-canvased-video [stream]="stream"></app-canvased-video>
  </ng-container>
  <ng-template #plainVideo>
    <app-plain-video [stream]="stream"></app-plain-video>
  </ng-template>
</ng-container>
